import create from "zustand";

interface PaypalState {
    isPaypalLoading: boolean;
    setIsPaypalLoading: (isPaypalLoading: boolean) => void;

    isPaypalPerforming: boolean;
    setIsPaypalPerforming: (p: boolean) => void;
}

export const usePaypalState = create<PaypalState>(
    (set, get) => ({
        isPaypalLoading: false,
        setIsPaypalLoading: (isPaypalLoading) => set( { isPaypalLoading } ),

        isPaypalPerforming: false,
        setIsPaypalPerforming: (isPaypalPerforming) => set ( { isPaypalPerforming } ),
    })
);
